import { AssortmentModel } from '@models/assortment-model';

export class AssortmentCalculator {
	public static FindMissingAssortments(model: Array<AssortmentModel | undefined>, assortments?: Array<string>): (AssortmentModel | undefined)[] {
		const result = new Array<AssortmentModel | undefined>();

		if (model && assortments) {
			model.forEach(assort => {
				if (!assortments.some(x => x === assort?.Code)) {
					result.push(assort);
				}
			});
		}

		return result;
	}
}